import { render } from "./OidoBubble.vue?vue&type=template&id=456cf17b&scoped=true"
import script from "./OidoBubble.vue?vue&type=script&lang=js"
export * from "./OidoBubble.vue?vue&type=script&lang=js"

import "./OidoBubble.vue?vue&type=style&index=0&id=456cf17b&scoped=true&lang=css"
import "./OidoBubble.vue?vue&type=style&index=1&id=456cf17b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-456cf17b"]])

export default __exports__